import React, { useState, useEffect } from 'react'
import $t from '../../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../../actions'
import Page from '../../../common/Page/Page'
import config from '../../../../config.json'
import { filterAppointmentsInQueue } from '../../../../utils/appointmentsUtils'
import { isNil } from 'ramda'
import ActionButton from '../../../common/ActionButton'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import { clinicTypes } from '../../../../consts/ClinicConsts'
import Dialog from '../../../common/Dialog'
import { Button } from 'antd'

import './ScheduleSelectPage.css'

dayjs.extend(duration)
dayjs.extend(utc)

export const ScheduleSelectPage = ({ onNext, designated }) => {
  const dispatch = useDispatch()
  const [isMoreOptions, setIsMoreOptions] = useState()

  const isTimeWindowLoading = useSelector(
    state => state.getCare?.isTimeWindowLoading
  )
  const { isTechnicalIssues } = useSelector(state => state.getCare)
  const { eta, appointments, timeWindows } = useSelector(
    state => state.appointments
  )
  const blockEarliest = useSelector(state => state.getCare.blockEarliest)

  const isAppointmentInQueue =
    filterAppointmentsInQueue(appointments).length > 0

  const selectedService = useSelector(state => state.getCare.selectedService)
  const isPCPFlow = useSelector(state => state.getCare.isPCPFlow)

  const isEarliestDisabled =
    eta > 60 ||
    blockEarliest ||
    isAppointmentInQueue ||
    selectedService !== clinicTypes.PRIMARY ||
    designated ||
    isPCPFlow?.designated

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.APPOINTMENT_TIMEWINDOWS_REQUESTED, {
        designated: isPCPFlow ? isPCPFlow?.designated : designated,
      })
    )
  }, [])

  const onEarliestSelected = () => {
    setIsMoreOptions(false)
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'earliest_time_slot_selected',
      })
    )
    dispatch(
      Actions.createAction(Actions.APPOINTMENT_TIME_SELECTED, {
        option: 'earliest',
      })
    )
  }

  const navigateHome = () => {
    dispatch(Actions.createAction(Actions.BOT_WIZARD_CLOSED))
  }

  const contactSupport = () => {
    dispatch(Actions.createAction(Actions.SUPPORT_CLICK))
  }

  const onMoreOptionSelected = () => {
    setIsMoreOptions(true)
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'choose_time_selected',
      })
    )
  }

  const renderTimeWindowOptions = () => {
    return (
      <div className="schedule-page-container time-window">
        <ul className="time-option-list">
          {timeWindows?.map(({ option, status }, i) => {
            const timeDisplay = dayjs(option)
              .local()
              .format(config.futureAppointmentDateFormat)
            return (
              <li
                key={i}
                className="option-item list-item trackable"
                data-name="time-option"
                data-disabled={status === 'disabled'}
                onClick={() => {
                  dispatch(
                    Actions.createAction(Actions.APPOINTMENT_TIME_SELECTED, {
                      option,
                      optionDisplayTime: timeDisplay,
                    })
                  )
                }}
              >
                {timeDisplay}{' '}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
  return (
    <Page
      className="schedule-select-page"
      title={
        isMoreOptions || isEarliestDisabled
          ? $t('scheduleSelectPage.moreOptionsTitle')
          : $t('scheduleSelectPage.title')
      }
      subtitle={
        isEarliestDisabled || isMoreOptions
          ? ''
          : $t('scheduleSelectPage.estimateETA') +
            dayjs.duration(Math.floor(eta), 'minutes').asMinutes() +
            $t('scheduleSelectPage.minutes')
      }
      loading={isTimeWindowLoading}
    >
      {isMoreOptions || isEarliestDisabled ? (
        renderTimeWindowOptions()
      ) : (
        <div className="schedule-page-container">
          <ActionButton
            label={$t('scheduleSelectPage.earliest')}
            iconName="fast"
            isVertical
            size={40}
            className="earliest-action schedule-action trackable"
            data-selected={!isNil(isMoreOptions) && !isMoreOptions}
            onPress={onEarliestSelected}
          />
          <ActionButton
            label={$t('scheduleSelectPage.moreOptions')}
            iconName="calendarsearch"
            isVertical
            size={40}
            className="more-action schedule-action trackable"
            data-selected={isMoreOptions}
            onPress={onMoreOptionSelected}
          />
        </div>
      )}
      <Dialog
        isVisible={isTechnicalIssues}
        footerActions={[
          <Button
            key="1"
            className="dialog-action"
            type="primary"
            onClick={() => contactSupport()}
          >
            {$t('common.contact')}
          </Button>,
          <Button
            key="2"
            className="dialog-action"
            onClick={() => navigateHome(false)}
          >
            {$t('common.backToHome')}
          </Button>,
        ]}
        onCancel={() => navigateHome(false)}
        className="schedule-page-dialog"
      >
        <div className="schedule-page-body">
          {$t('scheduleSelectPage.technicalIssues')}
        </div>
      </Dialog>
    </Page>
  )
}

export default ScheduleSelectPage
